export const PUBLIC_JOB_CREATE_ALERT_URL = '/subscriber/CreateAlertJson';

export const CONFIRMATION_TEMPLATE_TYPE_CODE = 'JobPublicJobSubscriberConfirmationEmail';
export const PUBLIC_JOB_SUBSCRIPTION_FORM_NAME = 'PublicJobSubscriptionForm';

export enum SubscriberTypeId {
	PublicJob = 1,
}

export enum SavedFilterType {
	PublicJob = 33,
}
